import { useLayoutEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router';
import cn from 'classnames';
import { CompetitionSwitcherProps } from './CompetitionSwitcher';
import { Image } from '../../../../common/components/Image';
import { MatchFilterConfig } from '@repo/types';

type CompetitionSwitcherMobileProps = CompetitionSwitcherProps;

export function CompetitionSwitcherMobile({ selectedCompetition, matchFilters }: CompetitionSwitcherMobileProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const onOpenDropdown = () => {
    setIsOpen(true);
  };

  const onCloseDropdown = (e: any) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  const onCompetitionSelect = (competition: MatchFilterConfig) => {
    searchParams.set('competition', competition.competitions);
    searchParams.delete('team');
    setSearchParams(searchParams);
  };

  const onClearCompetition = () => {
    searchParams.delete('competition');
    setSearchParams(searchParams);
  };

  useLayoutEffect(() => {
    document.addEventListener('click', onCloseDropdown);

    return () => {
      document.removeEventListener('click', onCloseDropdown);
    };
  });

  return (
    <div className="team-switcher" ref={ref}>
      <div className="team-switcher__select" onClick={onOpenDropdown}>
        <span className="team-switcher__selected-label">
          {selectedCompetition ? selectedCompetition.label : 'Filter by competition'}
        </span>
        <Image className="team-switcher__select-icon" src={'chevron-left.svg'} alt={'expand'} width={24} height={24} />
      </div>
      <ul
        className={cn('team-switcher__options-list', {
          'team-switcher__options-list--open': isOpen,
        })}
      >
        <li className="team-switcher__options-list-item" data-value={''} onClick={onClearCompetition}>
          Filter by competition
        </li>
        {matchFilters.map((matchFilter, index) => (
          <li
            className="team-switcher__options-list-item"
            data-value={matchFilter.competitions}
            onClick={() => onCompetitionSelect(matchFilter)}
            key={`${matchFilter.label}-${index}`}
          >
            {matchFilter.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
